import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';

@Component({
  selector: 'app-info-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss']
})
export class InfoModalComponent {
  modalRef = inject(MdbModalRef<InfoModalComponent>);

  // Dati passati alla modale
  title: string = '';
  message: string = '';
  showCloseButton: boolean = true;

  /**
   * Chiude la modale
   */
  close(): void {
    this.modalRef.close();
  }
}

